import React, { Fragment, useCallback, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { OAuth2ScopeOperations } from './../../../state/ducks/oauth2/scope';

import { Table } from 'app/components';

import { Link } from 'react-router-dom';

import Fab from '@material-ui/core/Fab';

import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteIcon from '@material-ui/icons/Delete';

import { openSnackbar } from 'app/components/snackbar';

import utils from 'app/utils';

const OAuth2ScopesPage = () => {

    /**
     * Take dispatch from react-redux
     */
    const dispatch = useDispatch();

    /**
     * Search for scopes via Api
     */
    const search = useCallback( query => dispatch( OAuth2ScopeOperations.search( 'scopes', query ) ), [ dispatch ] );

    /**
     * Remove scope via Api
     */
    const remove = useCallback( id => dispatch( OAuth2ScopeOperations.remove( 'scope', id ) ), [ dispatch ] );

    /**
     * OAuth2Scopes blrf object
     */
    const scopesObject = useSelector( state => state.app.blrf.objects.scopes || state.app.blrf.defaultObject );

    const { data, meta } = useMemo( () => {
        return {
            data: scopesObject.data,
            meta: scopesObject.meta
        }
    }, [ scopesObject ]);

    const query = useMemo( () => {
        /**
         * When object is first created query will only contain { refs: 0, page: 1 }
         *
         * We want refs, so we change that. And we want to have default order.
         * All other aspects of query object is controlled via
         * Table component.
         */
         const hasOrder = Array.isArray(scopesObject.query.order) && scopesObject.query.order.length > 0;
         if (scopesObject.query.refs !== 0 || !hasOrder) {
            return { ...scopesObject.query, refs: 0, order: (hasOrder ? [...scopesObject.query.order ] : ['name ASC'] ) };
         }
         return scopesObject.query;
    }, [ scopesObject.query ] );

    const {
        loading,
        error
    } = scopesObject;

    const fields = [
        {
            label: 'Id',
            name: 'id',
            width: 2,
        },
        {
            label: 'Name',
            name: 'name',
            width: 4,
        }
    ];


    const renderRow = ({ id, name}, i) => ({
        key: id,
        cells: [
            id,
            name
        ]
    });

    const actions = [
        {
            icon: <DescriptionIcon />,
            component: Link,
            to: utils.getFullPath('admin/oauth2/scope/view/:id')
        },
        {
            icon: <CreateIcon />,
            component: Link,
            to: utils.getFullPath('admin/oauth2/scope/edit/:id')
        },
        {
            icon: <DeleteIcon />,
            onClick: ( data ) => removeScope(data.id),
            confirm: {
                content: 'Are you sure you want to delete scope :name ?'
            }
        }
    ];

    const removeScope = async( id ) => {
        const ret = await remove( id );
        if (ret.type.indexOf('error') > 0) {
            openSnackbar('Failed to delete scope', 'error');
        } else {
            openSnackbar('Scope deleted', 'success');
            search( query );
        }
    }


    return (
        <Fragment>
            <Table
                fields={fields}
                renderRow={renderRow}
                actions={actions}
                loading={loading}
                search={search}
                query={query}
                data={data}
                meta={meta}
                error={error}
                />
            <Fab color='primary' style={{ float: 'right' }} variant='extended' component={Link} to={utils.getFullPath('admin/oauth2/scope/add')}>
                <AddIcon />
                Add scope
            </Fab>
        </Fragment>
    );
};

export default OAuth2ScopesPage;
